// @flow strict

import React, { useState } from 'react';
import AgendaCalendar from './../../components/AgendaCalendar';
import { useMemberStore } from '../../store/memberStore';
import useReservationStore from '../../store/reservationStore';

function WorkersPage() {
    const [reservations, setReservations] = useState([])
    const { isLoadingReservationsEmployee, reservationsEmployee, getAvailableEmployee } = useMemberStore();
    const { reservationsByDateRange, isLoadingByDateRange, getReservationsByDateRange } = useReservationStore();

    return (
        <div className="p-6">
            <h1 className="font-poppins font-semibold text-[18px] text-title mb-4">
                Planning des Employés
            </h1>
            <p className="font-nunito text-[14px] text-text mb-6">
                Visualisez et gérez les rendez-vous de votre équipe.
            </p>
            
            {/* <h2 className="font-poppins font-medium text-[15px] text-subtitle mb-2">
                Rdv qui ont été posé de l'heure d'ouverture du store
            </h2>
            <span className="font-nunito text-[14px] text-text">
                default show month: compteur du nombre de rdv par jour (stat de la journée: en attente, termine, annuler)
                show day: 
            </span> */}
            
            <AgendaCalendar data={reservations} />
        </div>
    );
};

export default WorkersPage;